import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "258",
  "slug": "top-trending-mapping-games-2026",
  "title": "Mapping Games With Different Kinds of Clues",
  "excerpt": "Five formats to compare, without unsupported claims about growth or popularity.",
  "date": "2026-05-11",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1569428034239-f9565e32e224?w=800&q=80",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "A list of trending games needs comparable audience data. This guide instead compares the clues used by different map games, so you can choose a format without relying on an unsupported popularity ranking."
    },
    {
      "type": "heading",
      "text": "A country shape"
    },
    {
      "type": "paragraph",
      "text": "Worldle presents an outline and gives feedback after a guess. The limited starting information makes the country shape central to the task."
    },
    {
      "type": "heading",
      "text": "A route across borders"
    },
    {
      "type": "paragraph",
      "text": "Travle asks you to connect countries. Read its rules for allowed connections, then compare the route you tried with the accepted answer."
    },
    {
      "type": "heading",
      "text": "A street scene"
    },
    {
      "type": "paragraph",
      "text": "WorldGuessr and OpenGuessr offer street-view location guessing. Inspect a sample round to see whether the map coverage and controls suit you."
    },
    {
      "type": "heading",
      "text": "A moving scene"
    },
    {
      "type": "paragraph",
      "text": "City Guesser supplies video clues. Notice what becomes visible as the scene progresses, including signs or a wider view of the street."
    },
    {
      "type": "heading",
      "text": "An overhead landscape"
    },
    {
      "type": "paragraph",
      "text": "EarthGuessr uses satellite imagery. Begin with large features such as a coastline or valley, then test whether smaller details support your candidate location. It is included here as the publisher's game, not as the winner of an independent ranking."
    }
  ],
  "sources": [
    {
      "title": "Worldle: rules and free daily puzzle",
      "url": "https://worldle.teuteuf.fr/"
    },
    {
      "title": "Travle: route puzzle and rules",
      "url": "https://travle.earth/"
    },
    {
      "title": "WorldGuessr: free street-view game",
      "url": "https://www.worldguessr.com/"
    },
    {
      "title": "OpenGuessr: game and access",
      "url": "https://openguessr.com/"
    },
    {
      "title": "City Guesser: video-based location games",
      "url": "https://virtualvacation.us/guess"
    }
  ],
  "relatedSlugs": [
    "best-free-geography-games-2026"
  ]
};
